require('babel-polyfill');
const $ = require('jquery');
const THREE = require('three');

window.jQuery = $;
window.$ = $;
window.THREE = THREE;

//add jquery plugins
require('./vendor/jquery.tapevent');

//initialize custom modules
require('./general').init();
// require('./media').init();
// require('./utils/social').init();
require('./storyHandler').init()

if(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
  //ios scrolling fix
  $('body,html').css({
    position: 'fixed',
    top: 0,
    left: 0
  });
}